import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

//import Textfield from "../shared/textfield";
// import {
//   DatePicker,
//   LocalizationProvider,
//   TimePicker,
// } from "@mui/x-date-pickers";
// import dayjs from "dayjs";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import { buttonRed, darkcolor, dialogEditEvent, lightcolor, pcolor, rcolor } from "../../style2";

export default function ViewMedication({
  open,
  handleClose,
  eventType,
  eventData
}) {

  const [eventDataDialog, setEventDataDialog] = useState(null);

  useEffect(() => {
    setEventDataDialog(eventData);
  }, [eventData]);

  //const [showAccordion, setShowAccordion] = useState(false);
  //const eventDate = new Date()
  if (eventDataDialog !== null && eventDataDialog !== undefined) {
    return (
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <Box sx={{ ...dialogEditEvent, backgroundColor: lightcolor }}>
          <Grid item xs={12} align="center">
            <DialogTitle style={{ textAlign: "left" }}>
              <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>{eventDataDialog.medicineName}</Typography>
            </DialogTitle>
          </Grid>
          <DialogContent style={{ height: "380px" }}>
            <Grid container spacing={3}>
              {eventDataDialog.dose !== "" ? <Grid item xs={12} style={{ color: darkcolor, fontSize: "14px" }}>{eventDataDialog.dose}</Grid> : null}
              <Grid item xs={12}>
                {eventDataDialog.medicationDates.map((date, index) => (
                  <Accordion xs={12} style={{ marginBottom: "15px", boxShadow: "none", border: "none" }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: rcolor, fontSize: "2rem", padding: 0 }} />} aria-controls="panel1a-content" id="panel1a-header">
                      <Typography style={{ color: darkcolor }}>
                        {moment(date.startDate).format("DD.MM.YYYY")} {date.endDate != null ? " - " + moment(date.endDate).format("DD.MM.YYYY") : null}
                      </Typography>{" "}
                    </AccordionSummary>
                    <AccordionDetails>
                      {date.medicationDosages && (
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography style={{ color: pcolor, fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>Frequency</Typography>
                            {date.medicationDosages.map((dosageDetail) => (
                              <Typography key={dosageDetail.id} style={{ color: darkcolor, fontSize: "16px", marginBottom: "5px" }}>
                                {dosageDetail.frequency}
                              </Typography>
                            ))}
                          </Grid>
                          <Grid item xs={6}>
                            <Typography style={{ color: pcolor, fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>Dosage</Typography>
                            {date.medicationDosages.map((dosageDetail) => (
                              <Typography key={dosageDetail.id} style={{ color: darkcolor, fontSize: "16px", marginBottom: "5px" }}>
                                {dosageDetail.dosage}
                              </Typography>
                            ))}
                          </Grid>
                          {date.description !== "" ? <Grid item xs={12}>
                            <Typography style={{ color: pcolor, fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>Description</Typography>
                            <Typography style={{ color: darkcolor, fontSize: "16px", marginBottom: "10px" }}>
                              {date.description}
                            </Typography>
                          </Grid> : null}

                        </Grid>
                      )}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>
            </Grid>
          </DialogContent>
          <Box m={2} />
          <DialogActions>
            <Grid container alignItems="center">
              <Grid item xs={12} container justifyContent="center">
                <Button sx={buttonRed} onClick={handleClose}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Box>
      </Dialog>
    );
  } else {
    return null;
  }
}
